import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '主体名称',
      isDisabled: true
    },
    {
      field: 'total',
      type: 'input',
      label: '留痕总数',
      placeholder: '请输入留痕总数'
    },
    {
      field: 'used',
      type: 'input',
      label: '已使用数量',
      placeholder: '请输入已使用数量'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
